import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  HashRouter,
  Link,
} from "react-router-dom";
import { AnimatePresence } from "framer-motion";

// Components
import Home from "./pages/Home";
import Daybreak from "./pages/Daybreak";
import ScrollToTop from "./helpers/ScrollToTop";

const AppRoutes = () => {
  return (
    <>
      <HashRouter basename="/Chai-Pin-Zheng">
        <Switch>
          <Route exact path="/">
            <ScrollToTop>
              <Home />
            </ScrollToTop>
          </Route>
          <Route path="/Daybreak">
            <ScrollToTop>
              <Daybreak />
            </ScrollToTop>
          </Route>
        </Switch>
      </HashRouter>
    </>
  );
};

export default AppRoutes;
